import { useSelector } from "react-redux";
import {
  goToCFI,
  goToFirstPage,
  goToNextPage,
  goToPage,
  goToPrevPage,
  goToURL,
} from "../../api/features/nav/actions";
import {
  getCurrentCfi,
  getCurrentPageBreak,
  getCurrentPageBreakLabel,
  hasNextContentDoc as hasNextContentDocSelector,
  hasPreviousContentDoc as hasPreviousContentDocSelector,
} from "../../api/features/nav/selectors";
import {
  getCurrentPage,
  getCurrentPageCfi,
  isPageLoading,
} from "../../api/features/nav/load-status/selectors";
import { getLastNumericPageBreakLabel } from "../../api/features/pagebreaks/selectors";
import { useAppDispatch } from "../../api/core/useAppDispatch";

export default function useNav() {
  const dispatch = useAppDispatch();
  const currentPage = useSelector(getCurrentPage);
  const hasNextContentDoc = useSelector(hasNextContentDocSelector);
  const hasPreviousContentDoc = useSelector(hasPreviousContentDocSelector);
  const lastNumericPageBreakLabel = useSelector(getLastNumericPageBreakLabel);

  const handleGoToNextPage = () => dispatch(goToNextPage());
  const handleGoToPrevPage = () => dispatch(goToPrevPage());
  const handleGoToFirstPage = () => dispatch(goToFirstPage());

  const handleGoToPage = (page, meta?) => dispatch(goToPage(page, meta));
  const handleGoToUrl = (url) => dispatch(goToURL(url));
  const handleGoToCFI = (cfi, opts?, meta?) =>
    dispatch(goToCFI(cfi, opts, meta));

  return {
    currentPageBreak: useSelector(getCurrentPageBreak),
    currentPageBreakLabel: useSelector(getCurrentPageBreakLabel),
    currentPageCfi: useSelector(getCurrentPageCfi),
    currentCfi: useSelector(getCurrentCfi),
    isPageLoading: useSelector(isPageLoading),
    handleGoToNextPage,
    handleGoToPrevPage,
    goToFirstPage: handleGoToFirstPage,
    currentPage,
    hasNextPage: hasNextContentDoc,
    hasPreviousPage: hasPreviousContentDoc,
    lastNumericPageBreakLabel,
    goToPage: handleGoToPage,
    goToCFI: handleGoToCFI,
    goToUrl: handleGoToUrl,
  };
}
